/* Card image dots — SUBTLE overlay. The card's own markup/rendering is untouched;
   dots (and horizontal swipes) simply swap the primary image's source in place. */
(function () {
  if (window.__ccar2) return;
  window.__ccar2 = true;
  function setIdx(media, idx) {
    var dots = media.querySelectorAll('.ccar__dots i');
    if (!dots.length) return;
    idx = (idx + dots.length) % dots.length;
    var img = media.querySelector('img.primary-image') || media.querySelector('img');
    if (!img) return;
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('on', i === idx);
    var d = dots[idx];
    if (img.getAttribute('src') === d.getAttribute('data-ccar-src')) return;
    img.style.opacity = '0';
    setTimeout(function () {
      img.setAttribute('srcset', d.getAttribute('data-ccar-srcset') || '');
      img.setAttribute('src', d.getAttribute('data-ccar-src'));
      if (img.complete) { img.style.opacity = ''; }
      else { img.addEventListener('load', function h() { img.style.opacity = ''; img.removeEventListener('load', h); }); }
    }, 120);
  }
  function curIdx(media) {
    var dots = media.querySelectorAll('.ccar__dots i');
    for (var i = 0; i < dots.length; i++) if (dots[i].classList.contains('on')) return i;
    return 0;
  }
  window.__ccarStep = function (media, dir) { setIdx(media, curIdx(media) + dir); };
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.ccar__dots i');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    var media = dot.closest('.card__media');
    setIdx(media, Array.prototype.indexOf.call(dot.parentElement.children, dot));
  }, true);
  /* Desktop: mouse-drag swipe. A completed drag suppresses the card link click. */
  var mx = null, my = null, mMedia = null, suppressClick = false;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') return;
    var media = e.target.closest && e.target.closest('.card__media');
    if (!media || !media.querySelector('.ccar__dots')) { mMedia = null; return; }
    mMedia = media; mx = e.clientX; my = e.clientY;
  });
  document.addEventListener('pointerup', function (e) {
    if (e.pointerType === 'touch' || !mMedia) return;
    var dx = e.clientX - mx, dy = e.clientY - my;
    var media = mMedia; mMedia = null;
    if (Math.abs(dx) < 30 || Math.abs(dy) > Math.abs(dx)) return;
    suppressClick = true;
    setTimeout(function () { suppressClick = false; }, 250);
    window.__ccarStep(media, dx < 0 ? 1 : -1);
  });
  document.addEventListener('click', function (e) {
    if (suppressClick && e.target.closest && e.target.closest('.card__media')) {
      suppressClick = false;
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  document.addEventListener('dragstart', function (e) {
    var media = e.target.closest && e.target.closest('.card__media');
    if (media && media.querySelector('.ccar__dots')) e.preventDefault();
  });
  var tx = null, ty = null, tm = null;
  document.addEventListener('touchstart', function (e) {
    var media = e.target.closest && e.target.closest('.card__media');
    if (!media || !media.querySelector('.ccar__dots')) { tm = null; return; }
    tm = media; tx = e.touches[0].clientX; ty = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!tm) return;
    var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
    var media = tm; tm = null;
    if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
    window.__ccarStep(media, dx < 0 ? 1 : -1);
  }, { passive: true });
})();
